import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getInspectionHeader, getInspectionList} from "../../../api/maintenance/InspectionService";
import React, {useEffect, useState} from "react";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../components/detailLayout";
import {CommonHistoryList} from "../../settings/history/subPages/CommonHistoryList";
import {getFlatCode} from "../../../components/commonmethod/CommonMethod";
import {getMaintenanceAssetsFromDetail, getMaintenanceHandlersFromDetail} from "../shared/maintenanceHandlerUtils";
import {CodeSpecNum, ContentCategory} from "../../../constant/CodeSpecNum";
import {skeleton} from "../../../redux/slice/apiSlice";
import {InspectionHeaderInfo} from "./subPages/InspectionHeaderInfo";
import {selectCodesByParentId} from "../../../api/code/CodeService";

const DEFAULT_TABS = [
    {clicked: true, name: "기본정보"},
    {clicked: false, name: "이력관리"},
];

function InspectionHeaderTab(){
    const { id } = useParams();
    const dispatch = useDispatch();

    const refreshContent = useSelector(state => state.status.refreshContent);
    const [inspection, setInspection] = useState({});
    const [assets, setAssets] = useState([]);
    const [handler, setHandler] = useState([]);
    const [flatInspectionCode, setFlatInspectionCode] = useState([]);
    const [childInspections, setChildInspections] = useState([]);
    const [tabs, setTabs] = useState(DEFAULT_TABS);
    const navigate = useNavigate();

    useEffect(() => {
        setInspection({});
        setAssets([]);
        setHandler([]);
        setFlatInspectionCode([]);
        setChildInspections([]);
        setTabs(DEFAULT_TABS);
    }, [id]);

    useEffect(() =>{
        let cancelled = false;

        Promise.all([
            getInspectionHeader(id),
            getInspectionList({entityId: id}, {page: 0, size: 500, sort: "inspectStartDate", desc: false}),
        ]).then(([ inspectionResponse, inspectionListResponse]) => {
            if (cancelled) return;

            if(inspectionResponse.status === 201) {
                if (inspectionResponse.data.errorCode = 'AUTHORITY') {
                    alert(inspectionResponse.data.reason)
                    navigate(-1)
                }
            }

            setInspection(inspectionResponse.data);
            setAssets(getMaintenanceAssetsFromDetail(inspectionResponse.data));
            setHandler(getMaintenanceHandlersFromDetail(inspectionResponse.data));
            setChildInspections(inspectionListResponse?.data?.content ?? []);

            return selectCodesByParentId(CodeSpecNum.InspectionRequestCode)
                .then(inspectionCodeResponse => {
                    if (!cancelled) {
                        setFlatInspectionCode(getFlatCode(inspectionCodeResponse));
                    }
                })
        }).finally(() => {
            if (!cancelled) {
                dispatch(skeleton(false));
            }
        });

        return () => {
            cancelled = true;
        };
    }, [id, dispatch, navigate, refreshContent]);

    if(Object.keys(inspection).length > 0 && Object.keys(flatInspectionCode).length > 0) {
        return (
            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
                <DetailHeroSummaryProvider>
                    <DetailTabBar tabs={tabs} setTabs={setTabs} />
                    {tabs[0].clicked && (
                        <InspectionHeaderInfo
                            id={id}
                            inspection={inspection}
                            assets={assets}
                            handler={handler}
                            childInspections={childInspections}
                        />
                    )}
                    {tabs[1].clicked && <CommonHistoryList id={id} tableName={"점검계획관리"} /> }
                </DetailHeroSummaryProvider>
            </div>
        );
    }
}

export {InspectionHeaderTab}
